import { redirect } from "@tanstack/react-router";

import { SIDEBAR_ROUTES } from "@onesolution/constants";

import { getUserFromSession } from "./session";

export function isUserRoleInAllowedRoles(
	userRoles: readonly string[],
	allowedRoles: readonly string[],
) {
	if (!allowedRoles || !allowedRoles.length) return true;
	if (!userRoles || !userRoles.length) return false;

	return allowedRoles.some((role) => userRoles.includes(`OS-${role}`));
}

export function protectSidebarRoute(path: string) {
	const toProtect = SIDEBAR_ROUTES.find((route) => route.path === path);
	if (!toProtect) throw `Invalid protectSidebarRoute path: ${path}`;

	return async () => {
		const userData = await getUserFromSession();

		if (!userData) throw redirect({ to: "/", replace: true });

		if (!isUserRoleInAllowedRoles(userData?.roles || [], toProtect.roles))
			throw redirect({ to: "/", replace: true });
	};
}
